var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _rect2, _rect3, _rect4, _path8, _rect5, _rect6, _rect7, _path9;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoGray(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 26,
    viewBox: "0 0 37 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 24,
    width: 36,
    height: 2,
    rx: 1,
    fill: "#B8B9BA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 16C2.77614 16 3 16.2239 3 16.5L3 24L2 24L2 16.5C2 16.2239 2.22386 16 2.5 16Z",
    fill: "#B8B9BA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 18C9.65685 18 11 19.3431 11 21L11 24L5 24L5 21C5 19.3431 6.34315 18 8 18Z",
    fill: "#B8B9BA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19 18C20.1046 18 21 18.8954 21 20L21 24L17 24L17 20C17 18.8954 17.8954 18 19 18Z",
    fill: "#B8B9BA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.2656 21.3938L36.2656 23.4834L28.6038 23.4834L28.6038 21.3938C29.3561 21.8957 29.9133 21.8957 30.4148 21.3938C30.5462 21.2231 30.6745 21.0838 30.8 20.9759L31.9894 20.9759C32.0943 21.0838 32.1964 21.2231 32.2954 21.3938C33.0477 22.3225 33.6745 22.3225 34.176 21.3938C34.5724 20.8544 35.4083 20.8544 36.2656 21.3938Z",
    fill: "#B8B9BA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9894 20.9759L30.8 20.9759C31.2316 20.6044 31.628 20.6044 31.9894 20.9759Z",
    fill: "#B8B9BA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2656 23.4834L36.2656 21.3938C35.4083 20.8544 34.5724 20.8544 34.176 21.3938C33.6745 22.3225 33.0477 22.3225 32.2954 21.3938C32.1964 21.2231 32.0943 21.0838 31.9894 20.9759L30.8 20.9759C30.6745 21.0838 30.5462 21.2231 30.4148 21.3938C29.9133 21.8957 29.3561 21.8957 28.6038 21.3938L28.6038 23.4834L36.2656 23.4834Z",
    fill: "#B8B9BA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2656 23.4834L36.2656 21.3938C35.4083 20.8544 34.5724 20.8544 34.176 21.3938C33.6745 22.3225 33.0477 22.3225 32.2954 21.3938C32.1964 21.2231 32.0943 21.0838 31.9894 20.9759L30.8 20.9759C30.6745 21.0838 30.5462 21.2231 30.4148 21.3938C29.9133 21.8957 29.3561 21.8957 28.6038 21.3938L28.6038 23.4834L36.2656 23.4834Z",
    fill: "#B8B9BA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 12,
    width: 4,
    height: 4,
    rx: 1,
    transform: "rotate(90 21 12)",
    fill: "#B8B9BA"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 12,
    width: 4,
    height: 4,
    rx: 1,
    transform: "rotate(90 27 12)",
    fill: "#B8B9BA"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 18,
    width: 4,
    height: 4,
    rx: 1,
    transform: "rotate(90 27 18)",
    fill: "#B8B9BA"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 5C14.7761 5 15 5.22386 15 5.5L15 23L14 23L14 5.5C14 5.22386 14.2239 5 14.5 5Z",
    fill: "#B8B9BA"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 8,
    width: 16,
    height: 2,
    rx: 1,
    transform: "rotate(145.213 15 8)",
    fill: "#B8B9BA"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 2.00195,
    width: 9,
    height: 2,
    rx: 1,
    transform: "rotate(145.213 21 2.00195)",
    fill: "#B8B9BA"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 12,
    width: 17,
    height: 2,
    rx: 1,
    transform: "rotate(-144.347 33 12)",
    fill: "#B8B9BA"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 10C31.7761 10 32 10.2239 32 10.5L32 18L31 18L31 10.5C31 10.2239 31.2239 10 31.5 10Z",
    fill: "#B8B9BA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoGray);
export default __webpack_public_path__ + "static/media/logo-gray.ae13811f8ea6d11354381fb5c6194002.svg";
export { ForwardRef as ReactComponent };